import { render, staticRenderFns } from "./KeyRelaysTable.vue?vue&type=template&id=7b711f8e&"
import script from "./KeyRelaysTable.vue?vue&type=script&lang=ts&"
export * from "./KeyRelaysTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports